'use client';

import { use } from 'react';
import { MacaronCardActiveContext, MacaronSelectionItemScopeContext } from './scope';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';
import { getMacaronCardSurfaceStyle, MACARON_CARD_SURFACE_CLASSNAME } from './cardSurface';

export function MacaronCard({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const child = typeof config.child === 'string' ? config.child : '';
  const inSelectionItem = use(MacaronSelectionItemScopeContext);
  return (
    <div
      className={inSelectionItem ? 'w-full rounded-2xl' : MACARON_CARD_SURFACE_CLASSNAME}
      style={inSelectionItem ? undefined : getMacaronCardSurfaceStyle()} // Selection-grid items in the imported Flutter showcases already own their outer button chrome. Rendering another frosted white card here creates the stray inner panel, pushes the icon/content off visual center, and makes the active green frame read like a double container.
    >
      <MacaronCardActiveContext.Provider value={true}>{child ? ctx.renderChild(child) : null}</MacaronCardActiveContext.Provider>
    </div>
  );
}
